// ============================================
// FILE: src/components/TermsScreen.jsx
// ============================================


import { ArrowLeft } from 'lucide-react';

const TermsScreen = ({ onBack = null, setActiveTab, appTheme = 'blue', isDesktop = false }) => {
  const goHome = () => setActiveTab && setActiveTab('home');

  // Header style
  const headerStyle = appTheme === 'white'
    ? { background: '#fff', color: '#222', boxShadow: '0 2px 16px 0 rgba(0,0,0,0.04)' }
    : { background: 'var(--header-gradient)', color: 'var(--text-light)' };

  // Card class
  const cardClass = appTheme === 'white'
    ? 'glass-card-white-theme'
    : 'bg-white rounded-xl shadow-sm p-4';

  // Card text color
  const cardTitleClass = appTheme === 'white' ? 'font-semibold text-gray-800 mb-3' : 'font-semibold text-gray-800 mb-3';
  const cardTextClass = appTheme === 'white' ? 'text-gray-700 text-sm leading-relaxed' : 'text-gray-600 text-sm leading-relaxed';

  return (
    <div className="pb-20 min-h-screen" style={{ background: 'var(--primary-bg)', color: 'var(--text-main)' }}>
      {/* ─── HEADER ─── */}
      <div className={`p-6 shadow-lg ${isDesktop ? 'rounded-3xl max-w-3xl mx-auto' : 'rounded-b-3xl'}`} style={headerStyle}>
        <div className="flex items-center gap-3 mb-4">
          <button
            onClick={onBack || goHome}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-semibold">Terms & Conditions</h2>
        </div>
      </div>
      {/* ─── CONTENT ─── */}
      <div className={`p-4 space-y-4 ${isDesktop ? 'max-w-3xl mx-auto' : ''}`}>
        <div className={cardClass}>
          <h3 className={cardTitleClass}>1. Acceptance of Terms</h3>
          <p className={cardTextClass}>
            By using this app, you agree to comply with and be bound by these terms and conditions. If you do not agree, please do not use the app.
          </p>
        </div>
        <div className={cardClass}>
          <h3 className={cardTitleClass}>2. User Responsibilities</h3>
          <p className={cardTextClass}>
            You agree to provide accurate information and not misuse the app. You are responsible for maintaining the confidentiality of your account.
          </p>
        </div>
        <div className={cardClass}>
          <h3 className={cardTitleClass}>3. Orders & Payments</h3>
          <p className={cardTextClass}>
            All orders are subject to acceptance and availability. Payments must be made as per the options provided in the app.
          </p>
        </div>
        <div className={cardClass}>
          <h3 className={cardTitleClass}>4. Intellectual Property</h3>
          <p className={cardTextClass}>
            All content, trademarks, and data on this app are the property of the company or its licensors. You may not use them without permission.
          </p>
        </div>
        <div className={cardClass}>
          <h3 className={cardTitleClass}>5. Limitation of Liability</h3>
          <p className={cardTextClass}>
            The company is not liable for any indirect, incidental, or consequential damages arising from your use of the app.
          </p>
        </div>
        <div className={cardClass}>
          <h3 className={cardTitleClass}>6. Changes to Terms</h3>
          <p className={cardTextClass}>
            We reserve the right to update these terms at any time. Continued use of the app constitutes acceptance of the new terms.
          </p>
        </div>
        <div className="text-center text-gray-500 text-xs">
         <p>Office No. 719, 83 Metro Street, SVH,Sector 83,Gurgaon, India</p>
        </div>  
        <div className="text-center text-gray-500 text-xs mt-6">
          &copy; {new Date().getFullYear()} Algolive OPC Private Limited. All rights reserved.  
        </div>      
      </div>
    </div>
  );
};

export default TermsScreen;
